import { render, staticRenderFns } from "./remove-dates-closed-popup.vue?vue&type=template&id=ccc1bfce"
import script from "./remove-dates-closed-popup.vue?vue&type=script&lang=js"
export * from "./remove-dates-closed-popup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports